export default __webpack_public_path__ + "static/media/617.e47bec23.png";